import svg from "./mean-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const MeanIcon = makeSvgIcon(svg);

export default MeanIcon;
